export default __webpack_public_path__ + "static/media/loginShape.320e81ed.svg";